import React from 'react';
import Dropdown from '../../dropdown/Dropdown';
import { Column, Row } from '../component/types';

interface Props<T> {
  tableColumns: Column<T>[];
  downloadColumns: Column<T>[];
  onClickItem: (id: string | number, hide: boolean) => void;
  isDownload?: boolean;
}

function ManageColumn<T extends Row>({
  tableColumns = [],
  downloadColumns = [],
  onClickItem,
  isDownload,
}: Props<T>) {
  return (
    <div className="d-flex justify-content-end py-5 px-12 gap-6">
      <Dropdown
        buttonType="button"
        buttonLabelName="Manage table columns"
        listItem={tableColumns.map((item) => ({
          id: item.id,
          name: item.name,
          show: Boolean(!item?.hide),
          onClick: () => onClickItem(item.id, item?.hide),
        }))}
        renderItem={(item) => (
          <div className="d-flex gap-6">
            <input type="checkbox" checked={item?.show} readOnly />
            {item.name}
          </div>
        )}
        dropdownPosition="right"
      />
      {isDownload ? (
        <Dropdown
          buttonType="button"
          buttonLabelName="Manage download columns"
          listItem={downloadColumns.map((item) => ({
            id: item.id,
            name: item.name as string,
            show: Boolean(!item?.hide),
            onClick: () => onClickItem(item.id, item?.hide),
          }))}
          renderItem={(item) => (
            <div className="d-flex gap-6">
              <input type="checkbox" checked={item?.show} readOnly />
              {`${item.name}`}
            </div>
          )}
          dropdownPosition="right"
          portal
        />
      ) : null}
    </div>
  );
}

export default ManageColumn;
